import { render, staticRenderFns } from "./TudoTemp.vue?vue&type=template&id=da1d2b92&scoped=true"
import script from "./TudoTemp.vue?vue&type=script&lang=js"
export * from "./TudoTemp.vue?vue&type=script&lang=js"
import style0 from "./TudoTemp.vue?vue&type=style&index=0&id=da1d2b92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da1d2b92",
  null
  
)

export default component.exports